import Vue from 'vue'

const srcjs = Vue.component('remote-script', {
    render: function(creatElement) {
        var self = this;
        return creatElement('script', {
            attrs: {
                type: 'text/javascript',
                src: this.src,
            },
            on: {
                load: function(event) {
                    self.$emit('load', event);
                },
                error: function(event) {
                    self.$emit('error', event)
                },
                readystatechange: function(event) {
                    if (this.readyState == 'complete') {
                        self.$emit('load', event);
                    }
                }
            },
        })
    },
    props: {
        src: {
            type: String,
            required: true
        }
    }
});

export default srcjs;


// WEBPACK FOOTER //
// ./src/assets/js/scriptjs.js